/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Forgetpwd.css';
import P from 'react-particles-js'
import Link from '../../components/Link'
import moment from 'moment'
import history from '../../history'
import { checkPhone, updatePwd, checkImgCode, getPhoneCode } from '../../controller';
import Logo from '../../components/Logo/Logo';

class Forgetpwd extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };
  constructor(props){
    super(props)
    this.state={
      m:null,
      url: '',      
      phone:'',
      pwd:'',
      pwdAg:'',
      imgCode:'',
      phoneCode:'',
      isError:false,
      isGetPhone:false,
      data:'',
      errTxt:'',
      isEdit:false,
      formDataPhone:null,
      formDataPsw:null,
      formDataPswAg:null,
      getCodeBtn:false,
      time:60,
      getPhoneTxt:false,
    }
    this.handleSubmit=this.handleSubmit.bind(this)
    this.handleChange=this.handleChange.bind(this)
    this.checkPic=this.checkPic.bind(this)
    this.getPhoneCode=this.getPhoneCode.bind(this)    
    this.valid=this.valid.bind(this)
    
  }
  tick=()=>{
    if(this.state.getPhoneTxt){
      this.setState((prevState)=>({
        time:prevState.time-1
      }))
    }
    if(this.state.time<=0){
      this.setState({getPhoneTxt:false})
    }
  }
  componentWillMount() {
    let m=moment().format('x')
    this.setState({
      m:m,
      url:`/digitalAssets/get_img_code?timestamp=${m}`
    })
  }
  componentDidMount() {
    this.interval=setInterval(()=>this.tick(),1000)
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  valid=(e)=>{
    const {value,name}=e.target
    // if(this.state.formDataPhone==true&&this.state.formDataPsw==true&&this.state.formDataPswAg==true){
    //   this.setState({
    //       getCodeBtn:true
    //   })
    // }
    if(name=='phone'){

      let reg=/^((1[3-9][0-9])+\d{8})$/
      if(reg.test(value)){
        checkPhone({
          phone: value
        })
          .then(res => {
            if(res.phone_register==true){
              this.setState({
                formDataPhone:true,
                getCodeBtn:true
              })
            }else{
              this.setState({
                formDataPhone:'phoneAg'
              })
            }
          })
        
      }else if(this.state.getPhoneTxt){
        
      }else{
        this.setState({
          formDataPhone:'phoneNot'
        })
      }
    }
  
    
    
    if(name=='pwd'){
      if(value!=''){
        this.setState({
          formDataPsw:true
        })
      }else{
        this.setState({
          formDataPsw:'pswNot'
        })
      }
    }
    if(name=='pwdAg'){
      if(value==''){
        this.setState({
          formDataPswAg:'pswNot'
        })
      }else if(value==this.state.pwd){
        this.setState({
          formDataPswAg:true
        })
      }else{
        this.setState({
          formDataPswAg:'pswAgNot'
        })
      }
    }

    
  }


  handleChange(e){
    const {name,value}=e.target
    this.setState({
      [name]:value,
      isError:false,
    })
    if(this.state.formDataPhone==true&&this.state.formDataPsw==true&&this.state.formDataPswAg==true){
      this.setState({
          getCodeBtn:true
      })
    }
  }
  handleSubmit(e){
    e.preventDefault()
    const {phone,imgCode,phoneCode,pwd,pwdAg}=this.state
    if(phone!=''&&imgCode!=''&&phoneCode!=''&&pwd!=''&&pwd==pwdAg){
      console.log('可以提交')
      this.setState({
        isError:false
      })

      updatePwd({
        phone,
        pwd,
        phone_code: phoneCode
      })
        .then(res => {
          if(res.err_code==0){        
            alert('密码修改成功')
            history.push('/Login')
          }else if(res.err_code==1){
            this.setState({errTxt:''})
          }else if(res.err_code==2){
            this.setState({errTxt:'手机号验证错误'})
          }else if(res.err_code==3){
            this.setState({errTxt:'该用户未注册'})
          }
        }) 
      
    }else{
      this.setState({
        isError:true
      })
    }
  }
  checkPic=(e)=>{
    if(e.target.value.length==4){
      const code=e.target.value
      checkImgCode({
        code,
        timestamp: this.state.m
      })
        .then(res => {
          if (res.err_code){
            isGetPhone:true        
          } else if (res.err_code==2) {
            this.setState({
              errTxt:'验证码已失效，请点击验证码图片刷新'
            })
          }    
        })
    }
  }

  getPhoneCode() {
    
    if(this.state.phone.length==11&&this.state.getCodeBtn&&!this.state.getPhoneTxt){
      const query = new FormData()
      query.set('phone', this.state.phone)
      query.set('type', '1')

      getPhoneCode(query)
        .then(res => {
          this.setState({
            data: res,
            time:60,
            getPhoneTxt:true,
          })
          console.log(this.state.data)
          if(res.err_msg=='phone_code is expired'){
            this.setState({errTxt:'验证码错误'})
          }else if(res.err_msg=='phone already exists'){
            this.setState({errTxt:'手机号已经注册'})
          }
        })
    }else if(this.state.getPhoneTxt){
      this.setState({
        errTxt:'验证码已发送',
        isErr:true
      })
    }else{
      this.setState({
        errTxt:'请输入正确手机',
        isErr:true
      })
    }
  }

  

  render() {
    
    const {phone,imgCode,phoneCode,isError,pwd,pwdAg,isEdit,formDataPhone,formDataPsw,formDataPswAg,getCodeBtn,getPhoneTxt,time}=this.state
    let random =Math.random()
    return (
      <div className={s.root}>
        <div className={s.bg}>

        <P
          params={{
            "particles": {
              "number": {
                "value": 40,
                "density": {
                  "enable": false,
                  "value_area": 80
                }
              },
              "color": {
                "value": "#ffd70d"
              },
              "shape": {
                "type": "circle",
                "stroke": {
                  "width": 0,
                  "color": "#000000"
                },
                "polygon": {
                  "nb_sides": 5
                },
                "image": {
                  "src": "img/github.svg",
                  "width": 100,
                  "height": 100
                }
              },
              "opacity": {
                "value": 0.5,
                "random": false,
                "anim": {
                  "enable": false,
                  "speed": 1,
                  "opacity_min": 0.1,
                  "sync": false
                }
              },
              "size": {
                "value": 24,
                "random": true,
                "anim": {
                  "enable": false,
                  "speed": 40,
                  "size_min": 0.1,
                  "sync": false
                }
              },
              "line_linked": {
                "enable": true,
                "distance": 150,
                "color": "#cccccc",
                "opacity": 0.4,
                "width": 1
              },
              "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                  "enable": false,
                  "rotateX": 600,
                  "rotateY": 1200
                }
              }
            },
            "interactivity": {
              "detect_on": "canvas",
              "events": {
                "onhover": {
                  "enable": false,
                  "mode": "grab"
                },
                "onclick": {
                  "enable": false,
                  "mode": "push"
                },
                "resize": true
              },
              "modes": {
                "grab": {
                  "distance": 140,
                  "line_linked": {
                    "opacity": 1
                  }
                },
                "bubble": {
                  "distance": 400,
                  "size": 40,
                  "duration": 2,
                  "opacity": 8,
                  "speed": 3
                },
                "repulse": {
                  "distance": 200,
                  "duration": 0.4
                },
                "push": {
                  "particles_nb": 4
                },
                "remove": {
                  "particles_nb": 2
                }
              }
            },
            "retina_detect": true
          }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%"
          }} />

      </div>
        <div className={s.loginbox}>
          <Logo className={s.logo} />
          <div className={s.loginform}>

            <form action="" method="post" onSubmit={this.handleSubmit}>

              <ul>
                <li><input type="text" value={phone} name='phone' onChange={this.handleChange} placeholder="手机" onBlur={this.valid}/>
                  <i></i>
                  {formDataPhone==null?null:<em className={s[formDataPhone]}></em>}
                </li>
                <li><input type="text" value={imgCode} name='imgCode' onBlur={this.checkPic} onChange={this.handleChange} placeholder="请输入图片验证码"/>
                  <i></i>
                  <img src={this.state.url}
                    className={s.picImg}
                    onClick={() => {
                      this.setState({ url: `/digitalAssets/get_img_code?timestamp=${this.state.m}` + '&' + random })
                    }
                    } />
                </li>
                <li><input type="text" value={phoneCode} name='phoneCode' onChange={this.handleChange} placeholder="请输入验证码"/>
                  <i></i>
                  <span
                    className={getCodeBtn?s.phoneCodeBtn:s.no}
                    onClick={this.getPhoneCode}
                    disabled={this.state.isGetPhone}
                  >{getPhoneTxt?time:'获取验证码'}</span>
                </li>
              
                <li><input type="password" value={pwd} name='pwd' onChange={this.handleChange} placeholder="请输入新密码" onBlur={this.valid}/>
                  <i></i>
                  {formDataPsw==null?null:<em className={s[formDataPsw]}></em>}
                </li>
                <li><input type="password" value={pwdAg} name='pwdAg'  onChange={this.handleChange} placeholder="请确认新密码" onBlur={this.valid}/>
                  <i></i>
                  {formDataPswAg==null?null:<em className={s[formDataPswAg]}></em>}
                </li>
              </ul>
              <span className={isError?s.show:s.hide}>账号或密码输入错误</span>
              <span >{this.state.errTxt}</span>

              <input type="submit" value="提交"/>

            </form>
            <span>
              <Link to='/login'>返回登录</Link>
            </span>
          </div>

        </div>
      </div>
    );
  }
}

export default withStyles(s)(Forgetpwd);



// WEBPACK FOOTER //
// src/routes/forgetpwd/Forgetpwd.js